import { Checkbox } from '@/components/ui/checkbox';
import { Field, FieldLabel } from '@/components/ui/field';
import { dataTestTransformer } from '@/utils/data-test-helper';
import React from 'react';

type FilterComponentProps = {
  checked: boolean;
  displayName: string;
  onToggle: (value: boolean) => void;
};

export const FilterComponent = ({ checked, displayName, onToggle }: FilterComponentProps): React.JSX.Element => {
  return (
    <Field orientation="horizontal">
      <Checkbox checked={checked}
        data-test={`checkbox-${dataTestTransformer(displayName)}`}
        id={`checkbox-${dataTestTransformer(displayName)}`}
        onCheckedChange={onToggle}
      />

      <FieldLabel isCheckbox
        className="flex items-start cursor-pointer gap-2 font-normal"
        htmlFor={`checkbox-${dataTestTransformer(displayName)}`}
      >
        {displayName}
      </FieldLabel>
    </Field>
  );
};
